import router from './router'

export default {
	moduleName: 'video',
	router
}



// WEBPACK FOOTER //
// ./src/core/modules/video/index.js